"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrendOrderMonitorType = exports.TrendOrderStatus = void 0;
var TrendOrderStatus;
(function (TrendOrderStatus) {
    TrendOrderStatus["prepare"] = "prepare";
    TrendOrderStatus["canceled"] = "canceled";
    TrendOrderStatus["rejected"] = "rejected";
    TrendOrderStatus["triggered"] = "triggered";
    TrendOrderStatus["waiting"] = "waiting";
    TrendOrderStatus["running"] = "running";
    TrendOrderStatus["canceling"] = "canceling";
})(TrendOrderStatus = exports.TrendOrderStatus || (exports.TrendOrderStatus = {}));
var TrendOrderMonitorType;
(function (TrendOrderMonitorType) {
    TrendOrderMonitorType["le"] = "LESS_EQUAL";
    TrendOrderMonitorType["ge"] = "GREATER_EQUAL";
})(TrendOrderMonitorType = exports.TrendOrderMonitorType || (exports.TrendOrderMonitorType = {}));
